import gql from 'graphql-tag';

export const deleteTag = gql`
  mutation deleteTag($id: UUID!) {
    deleteTag(id: $id)
  }
`;
